import type { ApiFilestackImageData } from 'api/types/ApiFilestackImageData';
import { Avatar } from 'components/Avatar/Avatar';
import { Icon } from 'components/Icon/Icon';
import { StyledVersionedRouterLink } from 'components/Link/StyledVersionedRouterLink';

import {
  CmsReactionsProfileInfoCardHolder,
  CmsReactionsProfileInfoCardLeft,
  CmsReactionsProfileInfoCardLocation,
  CmsReactionsProfileInfoCardLocationText,
  CmsReactionsProfileInfoCardNameLink,
  CmsReactionsProfileInfoCardSummary,
} from './CmsReactionsProfileInfoCard.styled';

type Props = {
  url: string;
  name: string;
  image: ApiFilestackImageData;
  location: string;
  summary: string;
};

export function CmsReactionsProfileInfoCard({
  url,
  name,
  image,
  location,
  summary,
}: Props) {
  const truncatedLocation = location.replace(', United States', '');
  return (
    <CmsReactionsProfileInfoCardHolder data-qa-id="cms-reactions-profile-info-card">
      <CmsReactionsProfileInfoCardLeft>
        <StyledVersionedRouterLink
          to={url}
          data-qa-id="cms-reactions-profile-info-card-avatar-link"
        >
          <Avatar image={image} name={name} size="md" />
        </StyledVersionedRouterLink>

        <CmsReactionsProfileInfoCardNameLink
          to={url}
          data-qa-id="cms-reactions-profile-info-card-name"
        >
          {name}
        </CmsReactionsProfileInfoCardNameLink>
      </CmsReactionsProfileInfoCardLeft>

      <div>
        <CmsReactionsProfileInfoCardSummary data-qa-id="cms-latest-reaction-avatars-summary">
          {summary}
        </CmsReactionsProfileInfoCardSummary>
        <CmsReactionsProfileInfoCardLocation data-qa-id="cms-reactions-profile-info-card-location">
          <Icon name="location" size={18} />
          <CmsReactionsProfileInfoCardLocationText title={truncatedLocation}>
            {truncatedLocation}
          </CmsReactionsProfileInfoCardLocationText>
        </CmsReactionsProfileInfoCardLocation>
      </div>
    </CmsReactionsProfileInfoCardHolder>
  );
}
